module.exports = __webpack_public_path__ + "assets/img/bg-home.976c46de.png";